import useStores from './useStore';

function useShowDataLogic() {
  const { UIStore } = useStores();
  const {
    conditionScore, mileage, predictionMonthsOut,
  } = UIStore;

  let showData = true;
  let showDataMessage = null;
  let predictionModel = true;

  if (conditionScore < 60) {
    showData = false;
    showDataMessage = 'The vehicle falls outside of condition parameters and cannot return an accurate estimated value.';
  }

  if (mileage >= 100000 || mileage === 'TMU') {
    showData = false;
    showDataMessage = 'The vehicle falls outside of mileage parameters and cannot return an accurate estimated value.';
  }

  if (!predictionMonthsOut || predictionMonthsOut.prediction === 0) {
    predictionModel = false;
    showData = false;
    showDataMessage = 'The vehicle submitted falls outside of the Year/Make/Model parameters and cannot return an accurate estimated value.';
  }

  return {
    showData,
    showDataMessage,
    predictionModel,
  };
}

export default useShowDataLogic;
